if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Back/forward cache can restore the page mid-redirect: unlock the button again.
        window.addEventListener('pageshow', (e) => {
          if (!e.persisted || !this.redirecting) return;
          this.redirecting = false;
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.redirecting || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            // A 429 or bot-check page comes back as HTML, not JSON: treat it as a failed add.
            return response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (err) {
                throw new Error('Cart add returned ' + response.status + ', not JSON');
              }
            });
          })
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(
                response.description ||
                  response.message ||
                  'That did not go into your cart. Check your connection and try again.'
              );

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // Keep the button locked until the cart page loads, so a second tap cannot add a second one.
              this.redirecting = true;
              window.location = window.routes.cart_url;
              // If the cart page never arrives (load stopped, very slow signal), unlock after 10s.
              // The item is already in the cart, so a later tap only adds another on purpose.
              setTimeout(() => {
                if (!this.redirecting) return;
                this.redirecting = false;
                this.submitButton.classList.remove('loading');
                this.submitButton.removeAttribute('aria-disabled');
                const spinner = this.querySelector('.loading__spinner');
                if (spinner) spinner.classList.add('hidden');
                if (window.L3DCart) window.L3DCart.refresh(false);
              }, 10000);
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('That did not go into your cart. Check your connection and try again.');
          })
          .finally(() => {
            if (this.redirecting) return;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          // Bring the message into view: it can be off screen after a sticky bar tap or under the tall STL waiver.
          const r = this.errorMessageWrapper.getBoundingClientRect();
          const header = document.getElementById('l3d-header');
          const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
          if (r.top < headerBottom || r.bottom > window.innerHeight) {
            this.errorMessageWrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
